import { getApiDomain } from "../../util/domains";

export function resetFileNamePdfVehicleStories(state) {
  state.fileNamePdfVehicleStories = "";
  state.fileNamePdfVehicleStoriesEmail = "";
}

export function setFileNamePdfVehicleStories(state, value) {
  state.fileNamePdfVehicleStories = getApiDomain() + "/storage/" + value;
  state.fileNamePdfVehicleStoriesEmail = "/" + value;
}

export function setShowPdfVehicleStories(state, value) {
  state.showPdfVehicleStories = value;
}

export function setLoadingPdf(state, value) {
  state.loadingPdf = value;
}

export function setVehiclesVehicleStories(state, data) {
  state.vehicles = data;
}

export function setSelectedVehicle(state, id) {
  state.selectedVehicle = state.vehicles.find(v => v.id === id);
}



// WEBPACK FOOTER //
// ./src/modules/vehicle-stories/mutations.js